import React, { useState } from 'react';
import { api } from '../api.js';

export default function ChangePasswordModal({ onClose }) {
  const [cur, setCur] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setMsg('');
    if (!cur || !next) { setErr('현재 비밀번호와 새 비밀번호를 입력하세요.'); return; }
    if (next.length < 8) { setErr('새 비밀번호는 8자 이상이어야 합니다.'); return; }
    if (next === cur) { setErr('새 비밀번호가 현재 비밀번호와 동일합니다.'); return; }
    if (next !== confirm) { setErr('새 비밀번호 확인이 일치하지 않습니다.'); return; }
    setBusy(true);
    try {
      const r = await api.changePassword({ current_password: cur, new_password: next });
      setMsg(r.message || '비밀번호가 변경되었습니다.');
      setCur(''); setNext(''); setConfirm('');
      setTimeout(() => onClose && onClose(), 1500);
    } catch (e) { setErr(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-medical-900/40 flex items-center justify-center p-4"
      onMouseDown={onClose}
    >
      <form
        onMouseDown={(e) => e.stopPropagation()}
        onSubmit={submit}
        className="bg-white rounded-2xl shadow-card w-full max-w-md p-6 border border-medical-100"
      >
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-medical-800">비밀번호 변경</h2>
          <button type="button" onClick={onClose} className="text-medical-500 hover:text-medical-700 text-xl leading-none">×</button>
        </div>

        <label className="block text-sm font-semibold text-medical-700 mb-1">현재 비밀번호</label>
        <input
          type="password" autoComplete="current-password"
          value={cur} onChange={(e) => setCur(e.target.value)}
          className="w-full mb-3 px-3 py-2 rounded-md border border-medical-200 focus:outline-none focus:ring-2 focus:ring-medical-400"
        />

        <label className="block text-sm font-semibold text-medical-700 mb-1">새 비밀번호 <span className="text-xs text-medical-500 font-normal">(8자 이상)</span></label>
        <input
          type="password" autoComplete="new-password"
          value={next} onChange={(e) => setNext(e.target.value)}
          className="w-full mb-3 px-3 py-2 rounded-md border border-medical-200 focus:outline-none focus:ring-2 focus:ring-medical-400"
        />

        <label className="block text-sm font-semibold text-medical-700 mb-1">새 비밀번호 확인</label>
        <input
          type="password" autoComplete="new-password"
          value={confirm} onChange={(e) => setConfirm(e.target.value)}
          className="w-full mb-3 px-3 py-2 rounded-md border border-medical-200 focus:outline-none focus:ring-2 focus:ring-medical-400"
        />

        {err && <div className="text-sm text-red-600 mb-2">{err}</div>}
        {msg && <div className="text-sm text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-3 py-2 mb-2">{msg}</div>}

        <div className="flex gap-2 mt-2">
          <button
            type="submit" disabled={busy}
            className="flex-1 px-4 py-2 rounded-md bg-medical-600 hover:bg-medical-700 disabled:opacity-60 text-white text-sm font-semibold"
          >
            {busy ? '변경 중…' : '변경'}
          </button>
          <button
            type="button" onClick={onClose}
            className="px-4 py-2 rounded-md border border-medical-200 text-medical-700 text-sm hover:bg-medical-50"
          >
            취소
          </button>
        </div>
      </form>
    </div>
  );
}
